import { useEffect, useState } from 'react'
import api from '../utils/api'
import { useHistory } from 'react-router-dom'
import cookies from '../utils/cookies'
import { userTypes } from '../utils/constants'
import useAuthStore from '../stores/Auth'
const useLogin = (email, password, submit) => {
  let history = useHistory()
  const authState = useAuthStore((state) => state)

  const [loginRequest, setLoginRequest] = useState({
    data: null,
    isLoading: false,
    error: null,
  })

  useEffect(() => {
    setLoginRequest((currentLoginRequest) => ({
      ...currentLoginRequest,
      // isLoading: false,
      // error: null,
    }))

    async function login() {
      if (email && password && submit) {
        try {
          setLoginRequest((currentLoginRequest) => ({
            ...currentLoginRequest,
            isLoading: true,
            error: null,
          }))
          const response = await api.post(
            '/login',
            { email, password, useSignedUrl: true },
            { includeToken: false }
          )
          if (response.data.type === userTypes.user) {
            setLoginRequest({
              data: null,
              isLoading: false,
              error: 'Usuario no autorizado',
            })
          } else {
            setLoginRequest({
              data: response.data,
              isLoading: false,
              error: null,
            })
            cookies.save('accesToken', response.data.token)
            cookies.save('user', response.data)
            if (response.data) {
              authState.storeUser(response.data, response.data.token)
            }
            if (response.data.type === userTypes.security) {
              history.push('/eventosEdificio')
            } else {
              history.push('/edificios')
            }
          }
        } catch (error) {
          setLoginRequest({
            data: null,
            isLoading: false,
            error: error?.response?.data?.message || 'Ah ocurrido un error.',
          })
        }
      }
    }
    login()
  }, [email, password, submit])

  return loginRequest
}

export default useLogin
